module.exports = __webpack_public_path__ + "media/images/search-fa07e149c3411a08ea1a7bb219e8dc7c.svg";